import { render, staticRenderFns } from "./realName.vue?vue&type=template&id=e936dee8&scoped=true&"
import script from "./realName.vue?vue&type=script&lang=js&"
export * from "./realName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e936dee8",
  null
  
)

export default component.exports